function convertColumn(item) {
  for (let field in item) {
    if (item[field] != null && item[field].includes('.')) {
      item[field] = new Intl.NumberFormat('en-EN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(item[field])
    }
  }
  return item
}
function convertCol(item) {
  for (let field in item) {
    if (item[field] != null && item[field].includes('.')) {
      item[field] = 100 * item[field] + '%'
    }
  }
  return item
}
function convertAll(transform) {
  for (let i = 0; i < transform.length; i++) {
    let item = transform[i]
    transform[i] = convertColumn(item)
  }
  return transform
}
function convertPercent(transform) {
  for (let i = 0; i < transform.length; i++) {
    let item = transform[i]
    transform[i] = convertCol(item)
  }
  return transform
}
module.exports = {
  convertColumn: convertColumn,
  convertAll: convertAll,
  convertPercent: convertPercent,
  getExchangeStocks: function (val) {
    switch (val) {
      case 'A':
        return 'XASE'
      case 'B':
        return 'XBOS'
      case 'C':
        return 'XCIS'
      case 'D':
        return 'FINR'
      case 'E':
        return 'EDGO'
      case 'H':
        return 'MRPL'
      case 'I':
        return 'XISE'
      case 'J':
        return 'ETGA'
      case 'K':
        return 'EDGX'
      case 'L':
        return 'LTSE'
      case 'M':
        return 'XCHI'
      case 'N':
        return 'XNYS'
      case 'P':
        return 'ARCX'
      case 'Q':
        return 'XNAS'
      case 'U':
        return 'MEMX'
      case 'V':
        return 'IEXG'
      case 'W':
        return 'CBSX'
      case 'X':
        return 'XPSX'
      case 'Y':
        return 'BATY'
      case 'Z':
        return 'BATS'
    }
  },
  getExchangeOptions: function (val) {
    switch (val) {
      case 'A':
        return 'XASE'
      case 'B':
        return 'XBOX'
      case 'C':
        return 'XCBO'
      case 'D':
        return 'EMLD'
      case 'E':
        return 'EDGO'
      case 'H':
        return 'GMNI'
      case 'I':
        return 'XISX'
      case 'J':
        return 'MCRY'
      case 'M':
        return 'XMIO'
      case 'N':
        return 'ARCO'
      case 'P':
        return 'MPRL'
      case 'Q':
        return 'XNDQ'
      case 'T':
        return 'XBXO'
      case 'W':
        return 'C2OX'
      case 'X':
        return 'XPHO'
      case 'Z':
        return 'BATO'
    }
  },
  getAccountClass: function (val) {
    switch (val) {
      case '1':
        return 'Cash'
      case '2':
        return 'Margin'
      case 'M':
        return 'Money Mkt'
    }
  },
  getCallType: function (val) {
    switch (val) {
      case 'CM':
        return 'Concentrated Maintenance'
      case 'DT':
        return 'Day Trading'
      case 'EM':
        return 'Equity Maintenance'
      case 'GF':
        return 'Good Faith Violations'
      case 'GW':
        return 'Good Faith Warnings'
      case 'JE':
        return 'JBO Equity'
      case 'LM':
        return 'Leverage Maintenance'
      case 'MD':
        return 'Money Due'
      case 'MT':
        return 'Regulation MT'
      case 'PE':
        return 'Portfolio Equity'
      case 'PM':
        return 'Portfolio Margin'
      case 'RM':
        return 'Required Maintenance Call'
      case 'RT':
        return 'Regulation T'
      case 'S1':
        return 'Type1 Shorts'
    }
  },
  getRestrictionCode: function (val) {
    switch (val) {
      case 'A':
        return 'ACAT	(Hard)'
      case 'B':
        return 'Restricted due to Both Reg-T and Daytrading call Violations	(Soft)' //
      case 'C':
        return 'Closed by Firm	(Hard)'
      case 'D':
        return 'DayTrading Violators	(Soft)' //
      case 'E':
        return 'Exempt Custody Fee Closed	(Hard)'
      case 'F':
        return 'Frozen for 90 Days	(Soft)' //
      case 'G':
        return 'Deposit Acct- No Funds Released W/O Executive Approval	(Hard)'
      case 'H':
        return 'No Assets without Executive Approval	(Hard)'
      case 'I':
        return 'Closed for Internal Conversion	(Hard)'
      case 'J':
        return 'AML restriction- No Money Out	(Soft)' //no money out (no withdrawals)
      case 'K':
        return 'INVALID ACCOUNT NAME	(Hard)'
      case 'L':
        return 'Legal Restriction	(Hard)'
      case 'M':
        return 'Returned Mail	(Hard)'
      case 'N':
        return 'Do Not Deconvert - See Conversions	(Hard)'
      case 'P':
        return 'No Paper Work on File	(Soft)' //
      case 'R':
        return 'Restricted Margin Call	(Soft)' //liquidating only and depositing only (no withdrawal or opening positions)
      case 'S':
        return 'Social Security Mismatch	(Hard)'
      case 'T':
        return 'Conversion in Progress	(Soft)' //liquidating or trading
      case 'U':
        return 'Deconversion in Progress	(Hard)'
      case 'W':
        return "Excessive Return Deposits'	(Hard)"
      case 'X':
        return 'Liquidating Orders Only	(Hard)'
      case 'Y':
        return 'Escheatment in Progress	(Hard)'
      case 'Z':
        return 'No Paper work on File - Hard Restriction	(Hard)'
      //hard no transactions or withdrawals can be conducted in the account
      //soft limited ability
      //when they log in they should see a notice saying you're account has been restricted please call us to discuss the restriction
    }
  },
}
